module.exports = __webpack_public_path__ + "img/biaoqian_yanglaoyuan.7ac03e19.png";